import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { spacing1x } from '../../../styles/spacing.js';
import { Resizer } from '../../Resizer/Resizer.js';
import { LateralBar } from './LateralBar.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var StyledContainer = styled.div.withConfig({
  displayName: "Lateral__StyledContainer",
  componentId: "sc-1kwz7n-0"
})(["&&{display:", ";flex-direction:", ";justify-content:left;align-items:center;gap:", ";}"], function (props) {
  return props.displayInline ? "flex" : "block";
}, function (props) {
  return props.displayInline ? "row-reverse" : void 0;
}, spacing1x);
var StyledTextDisplays = styled.div.withConfig({
  displayName: "Lateral__StyledTextDisplays",
  componentId: "sc-1kwz7n-1"
})(["&&{display:flex;justify-content:space-between;gap:", ";font-weight:400;font-size:12px;line-height:16px;white-space:nowrap;min-height:16px;overflow:hidden;}"], spacing1x);
var StyledStatusText = styled.span.withConfig({
  displayName: "Lateral__StyledStatusText",
  componentId: "sc-1kwz7n-2"
})(["&&{overflow:hidden;text-overflow:ellipsis;display:", ";}"], function (props) {
  return props.displayInline ? "none" : "block";
});
var StyledValueText = styled.span.withConfig({
  displayName: "Lateral__StyledValueText",
  componentId: "sc-1kwz7n-3"
})(["&&{display:block;", ";}"], function (props) {
  if (props.displayInline) {
    return css(["overflow:hidden;text-overflow:ellipsis;"]);
  }
});
var BREAKPOINT = 120;
var Lateral = function Lateral(props) {
  var status = props.status,
    statusText = props.statusText,
    valuePercentage = props.valuePercentage,
    valueText = props.valueText;
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    displayInline = _React$useState2[0],
    setDisplayInline = _React$useState2[1];
  return /*#__PURE__*/jsx(Resizer, {
    onResize: function onResize(_ref) {
      var width = _ref.width;
      return setDisplayInline(width <= BREAKPOINT);
    },
    children: function children(_ref2) {
      var ref = _ref2.ref;
      return /*#__PURE__*/jsxs(StyledContainer, {
        ref: ref,
        displayInline: displayInline,
        children: [/*#__PURE__*/jsxs(StyledTextDisplays, {
          children: [/*#__PURE__*/jsx(StyledStatusText, {
            displayInline: displayInline,
            children: statusText
          }), /*#__PURE__*/jsx(StyledValueText, {
            displayInline: displayInline,
            children: valueText
          })]
        }), /*#__PURE__*/jsx(LateralBar, {
          status: status,
          valuePercentage: valuePercentage
        })]
      });
    }
  });
};
Lateral.displayName = "Lateral";

export { Lateral };
